'use strict';

let keystrokes = '';

const updateContents = (ajaxError, node) => {
		node.innerHTML = `
			<div class="modal__body modal__body--alert" role="document" data-modal-body="">
				<div class="modal__header modal__header--text-left ">
					<h1 class="h2 modal__headline" id="ajax-error-modal-title">
						${ajaxError.modalTitle}
					</h1>
				</div>
				<div class="modal__main">
					${ajaxError.modalCopy}
				</div>
				<div class="modal__footer">
					<button class="button button--full-width button--red" data-modal-hide="ajax-error-modal">
						${ajaxError.modalButton}
					</button>
				</div>
			</div>
		`;
	},

	createModal = (ajaxError) => {
		let markup = `
			<div class="modal is-hidden" id="ajax-error-modal" tabindex="-1" role="dialog" aria-hidden="true" data-modal="">
				<div class="modal__body modal__body--alert" role="document" data-modal-body="">
					<div class="modal__header modal__header--text-left ">
						<h1 class="h2 modal__headline" id="ajax-error-modal-title">
							${ajaxError.modalTitle}
						</h1>
					</div>
					<div class="modal__main">
						${ajaxError.modalCopy}
					</div>
					<div class="modal__footer">
						<button class="button button--full-width button--red" data-modal-hide="ajax-error-modal">
							${ajaxError.modalButton}
						</button>
					</div>
				</div>
			</div>
		`;

		document.body.insertAdjacentHTML('beforeend', markup);
	},

	getErrorMessage = (errorObject) => {
		if (errorObject.response && errorObject.response.data) {
			return errorObject.response.data.Message;
		} else {
			return errorObject.config.data.Message;
		}
	},

	toTrollOrNotToTroll = (event) => {
		keystrokes += event.keyCode;

		if (document.querySelector('.logo') && keystrokes.length > 9 && keystrokes.indexOf('38384040373937396665') !== -1) {
			keystrokes = '';

			document.querySelector('.logo').classList.add('to-troll');

			setTimeout(() => {
				document.querySelector('.logo').classList.add('byeee');
			});

			document.removeEventListener('keydown', toTrollOrNotToTroll);
		}
	};

// set the state of an arbitrary checkbox
export const setChecked = (target, checked) => {
	target = typeof target === 'string' ? document.querySelector(target) : target;
	target.checked = checked;
};

// show the user an error if something bad happens
export const showUserError = (errorObject) => {
	let mockContents = {
			modalTitle: 'Netzwerkfehler',
			modalCopy: 'Ein Fehler ist aufgetreten. Bitte warten Sie einige Sekunden und versuchen Sie Ihre Aktion erneut.',
			modalButton: 'Schliessen'
		},
		modal = document.getElementById('ajax-error-modal'),
		modalContents = window.llbPortal ? window.llbPortal.ajaxError || mockContents : mockContents;

	modalContents.modalCopy = getErrorMessage(errorObject) ? getErrorMessage(errorObject) : modalContents.modalCopy;

	if (modal) {
		updateContents(modalContents, modal);
	} else {
		createModal(modalContents);
		modal = document.getElementById('ajax-error-modal');
	}

	window.llbstyle.modals.showModal(modal, document.body);
};

// move modals that are in grids out of it and append them to the body
export const moveModals = () => {
	const modals = Array.from(document.querySelectorAll('[class*=grid] .modal'));

	if (modals) {
		modals.forEach((modal) => {
			modal.parentNode.removeChild(modal);
			document.body.appendChild(modal);
		});
	}
};

export const preventModalTriggerFormSubmit = () => {
	const modalButtons = Array.from(document.querySelectorAll('[data-modal-show]:not([data-modal-show=""])'));

	if (modalButtons) {
		modalButtons.forEach((button) => {
			button.addEventListener('click', e => e.preventDefault());

			if (button.closest('label')) {
				const tooltipId = button.getAttribute('data-modal-show');

				if (tooltipId) {
					const tooltip = document.querySelector(`#${tooltipId}`);

					tooltip.addEventListener('click', e => e.preventDefault());
				}
			}
		});
	}
};

// initialize dynamically inserted modals
export const initializeModals = () => {
	setTimeout(() => {
		window.llbstyle.modals.initStaticModals();
	});
};

// gotta figure it out yourself, homie
export const easterEgg = () => {
	document.addEventListener('keydown', toTrollOrNotToTroll);
};
